import { makeStyles } from '@mui/styles'
import { BORDERRADIUS as borderRadius, backgroundImage, backgroundSize } from "@fedsim/constants";

export const useListStyles = makeStyles(theme => {
  return {
    root: {
      borderRadius,
      overflow: 'hidden'
    },
    selected: {
      margin: theme.spacing(0.4, 0)
    },
    listItem: {
      backgroundImage,
      backgroundSize,
      backgroundColor: theme.palette.mode === "dark" ? "#333" : "#fff"
    },
    container: {
      flexGrow: 1,
      display: 'flex',
      flexDirection: 'column',
      minWidth: 320,
      width: '100%'
      // [theme.breakpoints.down('md')]: {
      //   flexDirection: 'column',
      //   width: '100%'
      // }
    },
    list: {
      overflow: 'hidden'
    },
    presentation: { 
      display: 'flex',
      alignItems: 'center',
      transition: '1s ease-out',
      overflow: 'hidden',
      width: '100%',
      flex: 1,
      '&:hover': {
        transform: 'translateY(2px)'
      },
    },
    actions: {
      display: 'flex',
      justifyContent: 'end',
      alignItems: 'center',
      '& button': {
        // maxWidth: '180px'
      }
    }
  }
})
